import classNames from "classnames";

type Props = {
  className?: string;
};

const Skeleton = ({ className }: Props) => {
  return (
    <span
      className={classNames([
        "inline-block bg-gray-300 relative overflow-hidden",
        "after:animate-[wave_2s_linear_0.5s_infinite_normal_none_running] after:content-[''] after:absolute after:translate-x-[-100%] after:inset-0",
        "after:bg-gradient-to-r after:from-[transparent] after:via-[rgba(255,255,255,0.2)] after:to-[transparent]",
        className,
      ])}
    />
  );
};

export default Skeleton;
